import React from 'react'
import { useHistory } from 'react-router'

import style from './MyhouseRegisterTerms.module.scss'

import MyhouseRegisterTermsCollect from '@Components/atoms/MyhouseRegisterTermsCollect'
import MyhouseRegisterHeader from '@Components/atoms/MyhouseRegisterHeader'
import BlindContent from '@Components/atoms/BlindContent'

const MyhouseRegisterTerms: React.FC = () => {
  const history = useHistory()

  const handleCloseClick = (event: React.SyntheticEvent) => {
    event.preventDefault()
    history.goBack()
  }
  return (
    <>
      <MyhouseRegisterHeader onPrevClick={handleCloseClick} />
      <section id="content" className={`${style['content_myhouse']} ${style['type_terms--gathering']}`} role="main">
        <BlindContent />
        <div className={style.content_myhouse_inner}>
          <MyhouseRegisterTermsCollect />
        </div>

        <div className={style.myhouse_confirm}>
          <button type="button" className={style.myhouse_confirm_button} onClick={handleCloseClick}>
            확인
          </button>
        </div>
      </section>
    </>
  )
}

export default MyhouseRegisterTerms
